/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_ContactInputs */

const en_control_contact = /** @type {(inputs: Control_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const zh_control_contact = /** @type {(inputs: Control_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系支持`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Control_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_contact = /** @type {((inputs?: Control_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_contact(inputs)
	return zh_control_contact(inputs)
});
export { control_contact as "control.contact" }